export const SHOW_GALLERY = 'SHOW_GALLERY';
export const HIDE_GALLERY = 'HIDE_GALLERY';